<template>
  <main class="main customer_guarantee_apply_list" role="main" ref="main">
    <div class="gc_wrap">
      <section class="gc_sec_1">
        <div class="gc_top">
          <div class="top_txt">
            <h1>답변할 신청서를<br />선택해 주세요!</h1>
            <h3>
              설치희망일 기준 4일 이내에 답변을 주셔야,<br />
              만약 지원금을 받지 못하셨을 때 퍼스가 신속하게<br />
              도와드릴 수 있어요.
            </h3>
          </div>
          <div class="top_img">
            <img
              :src="
                require(`@/assets/front/images/v2/character/img_person_04.png`)
              "
            />
          </div>
        </div>
        <div class="gc_con" v-for="(item, index) in contents" :key="index">
          <label>
            <input
              type="radio"
              name="gal"
              v-model="selectIndex"
              :value="index"
            />
            <div class="txt"></div>
            <div class="txt02">
              <div class="con_li">
                <div class="li_title">거래매장</div>
                <div class="li_con">{{ item.store.storeName }}</div>
              </div>
              <div class="con_li">
                <div class="li_title">상품구성</div>
                <div class="li_con">
                  {{ item.item }}
                </div>
              </div>
              <div class="con_li">
                <div class="li_title">설치지역</div>
                <div class="li_con">{{ getArea(item.address) }}</div>
              </div>
              <div class="con_li">
                <div class="li_title">설치희망일</div>
                <div class="li_con">{{ getDate(item.installDate) }}</div>
              </div>
              <div class="con_li">
                <div class="li_title">약속지원금</div>
                <div class="li_con">
                  {{
                    (parseInt(item.cashSupport, 10) +
                      parseInt(item.giftCardSupport, 10) +
                      parseInt(item.giftItemSupport, 10))
                      | comma
                  }}원
                </div>
              </div>
            </div>
          </label>
        </div>
      </section>
      <section class="gc_sec_2">
        <div class="gc_btm">
          <div class="gc_btn" @click="goGuaranteeConfirm()">
            선택완료
          </div>
        </div>
      </section>
    </div>
    <DesignPopup2
      :show="designPopup"
      :data="{
        title: '지원금 입금 확인 안내',
        type: 'alert',
        msg: msg,
      }"
      @close="popupClose"
    />
  </main>
</template>

<script>
import format from 'date-fns/format';
import { ko as dateKo } from 'date-fns/locale';
import DesignPopup2 from '@/common/components/modal/DesignPopup2';

import {
  mapActions as mapInternetMapActions,
  mapGetters as mapInternetMapGetters,
} from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';

export default {
  name: 'GuaranteeApplyList',
  components: {
    DesignPopup2,
  },
  data() {
    return {
      designPopup: false,
      msg: '고객님께서는<br />이미 답변을 완료하였습니다.',
      confirmType: '', // 입금확인 : CONFIRM, 변경하기 : CHANGE, 신고하기 : REPORT
      contents: {},
      selectIndex: 0,
    };
  },
  async created() {
    console.log('this.$route.namethis.$route.name');
    console.log(this.$route.name);

    // alert(this.$route.query.confirmType);
    // 파라미터 type 확인
    this.confirmType = this.$route.query.confirmType;

    if (
      this.confirmType != 'CONFIRM' &&
      this.confirmType != 'CHANGE' &&
      this.confirmType != 'REPORT'
    ) {
      this.$router.push({ name: 'Home' });
      return;
    }

    // 신청서 리스트 가져오기 (2개 이상일 경우에만 남아있는다. 1개일경우 applyId 가지고 이동, 0일 경우 경고창 후 신청현황으로 이동)
    this.getGuaranteeApplyList();
  },

  async mounted() {},
  computed: {},
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  methods: {
    ...mapInternetMapActions([
      internetTypes.SELECT_INTERNET_SUPPORT_APPLY_LIST,
    ]),
    popupClose() {
      this.designPopup = false;
      this.goApplyMain();
    },
    goApplyMain() {
      this.$router.replace({
        name: 'Apply.Main',
      });
    },
    goGuaranteeConfirm() {
      this.$router.push({
        name: 'InternetCommerce.GuaranteeConfirm',
        query: {
          confirmType: this.confirmType,
          applyId: this.contents[this.selectIndex].id,
        },
      });
    },
    getGuaranteeApplyList() {
      this[internetTypes.SELECT_INTERNET_SUPPORT_APPLY_LIST]().then(res => {
        console.log('getGuaranteeApplyList');
        console.log(res);
        this.contents = res.content;
        const contentLeng = res.content.length;

        console.log('this.contents');
        console.log(this.contents);

        if (contentLeng == 0) {
          // 팝업 발생 후 신청현황으로
          this.designPopup = true;
        } else if (contentLeng == 1) {
          // confirmType, applyId 확인하고 페이지 이동
          this.$router.replace({
            name: 'InternetCommerce.GuaranteeConfirm',
            query: {
              confirmType: this.confirmType,
              applyId: this.contents[this.selectIndex].id,
            },
          });
        }
      });
    },
    getArea(address) {
      let strArr = address.split(' ');
      return strArr[0] + ' ' + strArr[1];
    },
    getDate(installDate) {
      const iDate = new Date(installDate);
      return format(iDate, 'yyyy.MM.dd (E)', { locale: dateKo });
    },
  },
};
</script>
